<!-- Clicking anywhere in the field opens the picker; the Add button is the
     keyboard path to the same picker. -->
<input-field [label]="label" (click)="openSelector()" class="isolate">
  <div class="gsi">
    @if (selections.length > 0) {
      <ul class="gsi__chips" [attr.aria-label]="label">
        @for (item of selections; track $index) {
          <li class="gsi__chip" (click)="$event.stopPropagation()">
            <span class="gsi__name">{{ item.name }}</span>
            <button
              type="button"
              class="gsi__remove"
              [attr.aria-label]="'Remove ' + item.name"
              (click)="removeSelection($event, item)"
            >
              <span class="bk-sym" aria-hidden="true">close</span>
            </button>
          </li>
        }
      </ul>
    } @else {
      <span class="gsi__empty">No {{ (label || '').toLowerCase() }} selected</span>
    }

    <button
      type="button"
      class="gsi__add"
      aria-haspopup="dialog"
      [attr.aria-label]="'Add ' + (label || '').toLowerCase()"
      (click)="$event.stopPropagation(); openSelector()"
    >
      <span class="bk-sym" aria-hidden="true">add</span>
      <span>Add</span>
    </button>
  </div>
</input-field>
